export default function TermsPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 py-8 space-y-6 text-[#ddd]" data-testid="terms-page">
      <h1 className="text-2xl font-bold text-[#FF0000] tracking-wider font-mono">Terms of Service</h1>
      <p className="text-xs text-[#666]">Last updated: May 2026</p>

      <div className="space-y-4 text-sm leading-relaxed">
        <section>
          <h2 className="text-base font-bold text-[#FF0000]/80 mb-2">1. Acceptance of Terms</h2>
          <p>By accessing or using MIRRORS (godmodesound.com), you agree to be bound by these Terms of Service. If you do not agree, do not use the service.</p>
        </section>
        <section>
          <h2 className="text-base font-bold text-[#FF0000]/80 mb-2">2. Description of Service</h2>
          <p>MIRRORS is a web-based audio experience platform providing generative sound, binaural audio, and music playback. MIRRORS is not a medical device and makes no therapeutic claims.</p>
        </section>
        <section>
          <h2 className="text-base font-bold text-[#FF0000]/80 mb-2">3. User Accounts</h2>
          <p>You are responsible for maintaining the confidentiality of your account credentials. You must provide accurate information when creating an account.</p>
        </section>
        <section>
          <h2 className="text-base font-bold text-[#FF0000]/80 mb-2">4. Subscriptions & Payments</h2>
          <p>Paid subscriptions are billed monthly. You may cancel at any time; cancellation takes effect at the end of the current billing period. Refunds are available within 14 days of purchase.</p>
        </section>
        <section>
          <h2 className="text-base font-bold text-[#FF0000]/80 mb-2">5. Intellectual Property</h2>
          <p>All content on MIRRORS, including audio compositions, visual designs, and software, is owned by GODMODE LLC and Vince Sinnott. Unauthorized reproduction is prohibited.</p>
        </section>
        <section>
          <h2 className="text-base font-bold text-[#FF0000]/80 mb-2">6. Disclaimer</h2>
          <p>MIRRORS is provided "as is" for entertainment and personal use. It is not intended to diagnose, treat, cure, or prevent any medical condition. Use at your own discretion. Do not use while driving or operating machinery.</p>
        </section>
        <section>
          <h2 className="text-base font-bold text-[#FF0000]/80 mb-2">7. Limitation of Liability</h2>
          <p>GODMODE LLC shall not be liable for any indirect, incidental, or consequential damages arising from use of the service.</p>
        </section>
        <section>
          <h2 className="text-base font-bold text-[#FF0000]/80 mb-2">8. Contact</h2>
          <p>Questions about these terms: <a href="mailto:contact@godmodesound.com" className="text-[#FF0000]/70 underline">contact@godmodesound.com</a></p>
        </section>
      </div>
      <p className="text-[8px] font-mono text-[#666] mt-8">GODMODE LLC</p>
    </div>
  );
}
